import { characters } from "@/mocks/nanny";

export default function Characters() {
  return (
    <section id="characters" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
            <div>
              <span className="text-primary-600 font-label text-sm tracking-[0.2em] uppercase">Cast</span>
              <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">人物角色</h2>
            </div>
            <p className="text-foreground-600 text-sm md:text-base max-w-md leading-relaxed">
              六个人，六种表达爱的方式。他们的错位与靠近，构成了这个故事的全部张力。
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {characters.map((c) => (
              <article
                key={c.name}
                className="group bg-background-100 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
              >
                <div className="w-full h-64 md:h-72 overflow-hidden">
                  <img
                    src={c.image}
                    alt={`《漂亮的保姆》角色 ${c.name} 定妆形象`}
                    title={`漂亮的保姆 角色 ${c.name}`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <div className="flex items-center justify-between gap-3">
                    <h3 className="font-heading text-xl font-semibold text-foreground-950">{c.name}</h3>
                    <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs whitespace-nowrap">
                      {c.tag}
                    </span>
                  </div>
                  <p className="mt-1 text-primary-700 text-sm font-medium">{c.role}</p>
                  <p className="mt-3 text-foreground-600 text-sm leading-relaxed">{c.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}